import React from 'react';
import type {
  AccordionSlimType,
  BannerWithSignupType,
  BlockBase,
  BlockSpecificData,
  TwoColumnHeroSlimType,
  BlockTypes,
  ButtonsSlimType,
  CalendlyType,
  CalendlyWithImageType,
  CampaignWithDeviceSlimType,
  DatoCms1ColumnYoutubeType,
  DatoCms2ColumnTextType,
  DatoCms3ColumnYoutubeType,
  DatoCmsBannerType,
  BannerWithEmailType,
  HeaderType,
  DatoCmsHeadlineType,
  HeadlineWithButtonReferenceType,
  HeroLeftAlignedContentSlimType,
  IconCardsWithTextReferenceType,
  IconCardsWithTextSlimType,
  DatoCmsImageType,
  DatoCmsOneColumnTextType,
  RelatedBlogPostsType,
  DatoCmsThreeColumnCardType,
  DatoCmsThreeColumnTextType,
  DatoCmsTwoColumnImageRichtextType,
  DatoCmsTwoColumnPriceTableType,
  DatoCmsTwoColumnRichtextImageType,
  TypeformType,
  TableOfContentType,
  VideoType,
  DowloadAppsSlimType,
  FAQReferenceType,
  FAQType,
  HeadlineSlimType,
  HeroWithBackgroundAndDeviceType,
  HeroWithBackgroundImageSlimType,
  HeroWithImageAndDeviceSlimType,
  IconCardsSlimBlockType,
  ImageSlimType,
  ImageWithDeviceSlimType,
  ImageWithLogoType,
  ImgCardsSlimType,
  InfoBoxTypeSlim,
  LinksWithArrowsType,
  NewsLetterType,
  PricingCardsSlimType,
  PricingHeaderBlockType,
  ProductVideoTabsSlimType,
  RichTextType,
  SalesforceLightningOutType,
  SocialMediaPresenceType,
  StorylaneDemoType,
  TestimonialSliderSlimType,
  TestimonialVideoSliderSlimType,
  TextWithImageSlimReferenceType,
  TextWithImageSlimType,
  TextWithVideoType,
  PricingAddOnsSectionType,
  IconCardsWithIconButtonsType,
  IndustryTeaserType,
  SuxxessWidgetType,
  BlogpostCTABannerType
} from '../../types/block';
import {BlogPostPreviewProps} from '../blogPost/BlogPostPreview';
import {Template} from '../../types/block';
import {BannerWithImageAndButtonComponentType} from './block/BannerWithImageAndButton';
import {ProvenExpertProps} from './block/provenExpert/ProvenExpert';

const DatoCmsShownNewsCarousel = React.lazy(() => import('./block/legacy/ShowNewsCarousel').then(module => ({default: module.DatoCmsShowNewsCarousel})));
const DatoCmsTwoColumnRichtextImage = React.lazy(() =>
  import('./block/legacy/TwoColumnRichtextImage').then(module => ({
    default: module.DatoCmsTwoColumnRichtextImage
  }))
);
const DatoCmsTwoColumnImageRichtext = React.lazy(() =>
  import('./block/legacy/TwoColumnImageRichtext').then(module => ({
    default: module.DatoCmsTwoColumnImageRichtext
  }))
);
const DatoCmsImage = React.lazy(() => import('./block/legacy/Image').then(module => ({default: module.DatoCmsImage})));
const DatoCmsThreeColumnText = React.lazy(() => import('./block/legacy/ThreeColumnText').then(module => ({default: module.DatoCmsThreeColumnText})));
const DatoCmsThreeColumnCard = React.lazy(() => import('./block/legacy/ThreeColumnCard').then(module => ({default: module.DatoCmsThreeColumnCard})));
const DatoCms2ColumnText = React.lazy(() => import('./block/legacy/2ColumnText').then(module => ({default: module.DatoCms2ColumnText})));
const DatoCmsOneColumnText = React.lazy(() => import('./block/legacy/OneColumnText').then(module => ({default: module.DatoCmsOneColumnText})));
const DatoCmsHeadline = React.lazy(() => import('./block/legacy/Headline').then(module => ({default: module.DatoCmsHeadline})));
const DatoCmsBanner = React.lazy(() => import('./block/legacy/Banner').then(module => ({default: module.DatoCmsBanner})));
const DatoCmsBannerWithSignup = React.lazy(() =>
  import('./block/legacy/BannerWithSignup').then(module => ({
    default: module.DatoCmsBannerWithSignup
  }))
);
const DatoCms1ColumnYoutube = React.lazy(() => import('./block/legacy/1ColumnYoutube').then(module => ({default: module.DatoCms1ColumnYoutube})));
const DatoCms3ColumnYoutube = React.lazy(() => import('./block/legacy/3ColumnYoutube').then(module => ({default: module.DatoCms3ColumnYoutube})));
const DatoCmsTwoColumnPriceTable = React.lazy(() =>
  import('./block/legacy/TwoColumnPriceTable').then(module => ({
    default: module.DatoCmsTwoColumnPriceTable
  }))
);
const DatoCmsVideo = React.lazy(() => import('./block/Video').then(module => ({default: module.Video})));
const DatoCmsRichtext = React.lazy(() => import('./block/Richtext').then(module => ({default: module.Richtext})));
const DatoCmsCalendly = React.lazy(() => import('./block/calendly/Calendly').then(module => ({default: module.Calendly})));
const DatoCmsSalesforceForm = React.lazy(() => import('./block/SalesforceForm').then(module => ({default: module.SalesforceForm})));
const DatoCmsTypeform = React.lazy(() => import('./block/Typeform').then(module => ({default: module.Typeform})));
const DatoCmsFormApi = React.lazy(() => import('./block/FormApi').then(module => ({default: module.FormApi})));
const DatoCmsTextWithImageSlim = React.lazy(() => import('./block/TextWithImageSlim').then(module => ({default: module.TextWithImageSlim})));
const DatoCmsImageWithDeviceSlim = React.lazy(() => import('./block/ImageWithDeviceSlim').then(module => ({default: module.ImageWithDeviceSlim})));
const DatoCmsIconCardsSlim = React.lazy(() => import('./block/IconCardsSlim').then(module => ({default: module.IconCardsSlim})));
const DatoCmsIconCardsWithTextSlim = React.lazy(() =>
  import('./block/IconCardsWithTextSlim').then(module => ({
    default: module.IconCardsWithTextSlim
  }))
);
const DatoCmsImgCardsSlim = React.lazy(() => import('./block/imgCard/ImgCardsSlim').then(module => ({default: module.ImgCardsSlim})));
const DatoCmsProductVideoTabsSlim = React.lazy(() => import('./block/ProductVideoTabsSlim').then(module => ({default: module.ProductVideoTabsSlim})));
const DatoCmsPricingCards = React.lazy(() => import('./block/PricingCardsSlim').then(module => ({default: module.PricingCardsSlim})));
const DatoCmsTwoColumnHeroSlim = React.lazy(() => import('./block/TwoColumnHeroSlim').then(module => ({default: module.TwoColumnHeroSlim})));
const DatoCmsHeroWithImageAndDeviceSlim = React.lazy(() =>
  import('./block/hero/HeroWithImageAndDeviceSlim').then(module => ({
    default: module.HeroWithImageAndDeviceSlim
  }))
);
const DatoCmsCampaignWithDeviceSlim = React.lazy(() =>
  import('./block/CampaignWithDeviceSlim').then(module => ({
    default: module.CampaignWithDeviceSlim
  }))
);
const DatoCmsHeroWithBackgroundImageSlim = React.lazy(() =>
  import('./block/hero/HeroWithBackgroundImageSlim').then(module => ({
    default: module.HeroWithBackgroundImageSlim
  }))
);
const DatoCmsFullwidthImageSlim = React.lazy(() => import('./block/FullwidthImageSlim').then(module => ({default: module.FullwidthImageSlim})));
const DatoCmsAccordionSlim = React.lazy(() => import('./block/AccordionSlim').then(module => ({default: module.AccordionSlim})));
const DatoCmsHeadlineSlim = React.lazy(() => import('./block/HeadlineSlim').then(module => ({default: module.HeadlineSlim})));
const DatoCmsButtonsSlim = React.lazy(() => import('./block/singleton/ButtonsSlim').then(module => ({default: module.ButtonsSlim})));
const DatoCmsIconCardsWithTextReference = React.lazy(() =>
  import('./block/singleton/IconCardsWithTextSlimReference').then(module => ({
    default: module.IconCardsWithTextSlimReference
  }))
);
const DatoCmsLinksWithArrow = React.lazy(() =>
  import('./block/LinksWithArrowSlim').then(module => ({
    default: module.LinksWithArrowSlim
  }))
);
const DatoCmsTestimonialSliderSlim = React.lazy(() =>
  import('./block/singleton/TestimonialSliderSlim').then(module => ({
    default: module.TestimonialSliderSlim
  }))
);
const DatoCmsTestimonialVideoSliderSlim = React.lazy(() =>
  import('./block/TestimonialVideoSliderSlim').then(module => ({
    default: module.TestimonialVideoSliderSlim
  }))
);
const DatoCmsHeroLeftAlignedContentSlim = React.lazy(() =>
  import('./block/hero/HeroLeftAlignedContentSlim').then(module => ({
    default: module.HeroLeftAlignedContentSlim
  }))
);
const DatoCmsSuxxessWidget = React.lazy(() => import('./block/SuxxessWidget').then(module => ({default: module.SuxxessWidget})));
const DatoCmsDownloadApps = React.lazy(() => import('./block/DownloadAppsSlim').then(module => ({default: module.DownloadAppsSlim})));
const DatoCmsProvenExpert = React.lazy(() => import('./block/provenExpert/ProvenExpert').then(module => ({default: module.ProvenExpert})));
const DatoCmsPricingAddOns = React.lazy(() => import('./block/singleton/PricingAddOns').then(module => ({default: module.PricingAddOns})));
const DatoCmsNewsletter = React.lazy(() => import('./block/Newsletter').then(module => ({default: module.Newsletter})));
const DatoCmsPricingHeader = React.lazy(() => import('./block/singleton/PricingHeader').then(module => ({default: module.PricingHeader})));
const DatoCmsHeroWithBackgroundAndDevice = React.lazy(() =>
  import('./block/hero/HeroWithBackgroundAndDevice').then(module => ({
    default: module.HeroWithBackgroundAndDevice
  }))
);
const DatoCmsRelatedBlogPostsBlock = React.lazy(() =>
  import('./block/RelatedBlogPostsBlock').then(module => ({
    default: module.RelatedBlogPostsBlock
  }))
);
const DatoCmsInfoBox = React.lazy(() => import('./block/InfoBoxSlim').then(module => ({default: module.InfoBoxSlim})));
const DatoCmsBannerWithImageAndButton = React.lazy(() =>
  import('./block/BannerWithImageAndButton').then(module => ({
    default: module.BannerWithImageAndButton
  }))
);
const DatoCmsTextWithVideo = React.lazy(() => import('./block/TextWithVideo').then(module => ({default: module.TextWithVideo})));
const DatoCmsFAQ = React.lazy(() => import('./block/FAQ').then(module => ({default: module.FAQ})));
const DatoCmsImageSlim = React.lazy(() => import('./block/ImageSlim').then(module => ({default: module.ImageSlim})));
const DatoCmsHeader = React.lazy(() => import('./block/Header').then(module => ({default: module.Header})));
const DatoCmsFaqsReference = React.lazy(() => import('./block/singleton/FaqsReference').then(module => ({default: module.FaqsReference})));
const DatoCmsBannerWithEmail = React.lazy(() => import('./block/BannerWithEmail').then(module => ({default: module.BannerWithEmail})));
const DatoCmsTextWithImageSlimReference = React.lazy(() =>
  import('./block/singleton/TextWithImageSlimReference').then(module => ({
    default: module.TextWithImageSlimReference
  }))
);
const DatoCmsHeadlineWithButtonsReference = React.lazy(() =>
  import('./block/singleton/HeadlinewithButtonsReference').then(module => ({
    default: module.HeadlineWithButtonsReference
  }))
);
const DatoCmsSocialMediaPresence = React.lazy(() =>
  import('./block/SocialMediaPresence').then(module => ({
    default: module.SocialMediaPresence
  }))
);
const DatoCmsCalendlyWithImage = React.lazy(() =>
  import('./block/calendly/CalendlyWithImage').then(module => ({
    default: module.CalendlyWithImage
  }))
);
const DatoCmsImageWithLogo = React.lazy(() => import('./block/ImageWithLogo').then(module => ({default: module.ImageWithLogo})));
const DatoCmsStorylaneDemo = React.lazy(() => import('./block/StorylaneDemo').then(module => ({default: module.StorylaneDemo})));
const DatoCmsTableOfContent = React.lazy(() => import('./block/TableOfContent').then(module => ({default: module.TableOfContent})));
const DatoCmsIconCardsWithIconButtonsBlock = React.lazy(() =>
  import('./block/IconCardsWithIconButtons').then(module => ({default: module.IconCardsWithIconButtonsBlock}))
);
const DatoCmsIndustryTeaser = React.lazy(() => import('./block/IndustryTeaser').then(module => ({default: module.IndustryTeaser})));
const DatoCmsBannerWithButtonSlim = React.lazy(() => import('./block/BlogpostCTABanner').then(module => ({default: module.BlogpostCTABanner})));

export type GenericBlock = BlockBase &
  BlockTypes & {
    // TODO: Remove on PD-9630
    showSignupForm?: boolean;
    showBadges?: boolean;
  };

//TODO https://ready2order.atlassian.net/browse/INTSERVICE-1048 - Refactor props
export type BlockProps = {
  block: GenericBlock;
  nextBlockSameType: boolean;
  previousBlockSameType: boolean;
  blockSpecificData?: BlockSpecificData;
  relatedBlogPostsByTag: {[tag: string]: BlogPostPreviewProps['data'][]};
  template: Template;
};

export const Block: React.FC<BlockProps> = props => {
  if (props.block.__typename === 'DatoCmsFormApi') {
    return (
      <>
        <DatoCmsFormApi />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsBannerWithImageAndButton') {
    return (
      <>
        <DatoCmsBannerWithImageAndButton
          isWide={props.template === Template.PAGE}
          noPadding={props.template !== Template.GLOSSARY_OVERVIEW}
          block={props.block as BannerWithImageAndButtonComponentType['block']}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsSuxxessWidget') {
    return <DatoCmsSuxxessWidget block={props.block as SuxxessWidgetType['block']} />;
  }
  if (props.block.__typename === 'DatoCmsHeadlineWithButtonsReference') {
    return (
      <>
        <DatoCmsHeadlineWithButtonsReference block={props.block as HeadlineWithButtonReferenceType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsHeroWithBackgroundAndDevice') {
    return (
      <>
        <DatoCmsHeroWithBackgroundAndDevice block={props.block as HeroWithBackgroundAndDeviceType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsHeadlineSlim') {
    return (
      <>
        <DatoCmsHeadlineSlim block={props.block as HeadlineSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsButtonsSlim') {
    return (
      <>
        <DatoCmsButtonsSlim block={props.block as ButtonsSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsLinksSlim') {
    return (
      <>
        <DatoCmsLinksWithArrow block={props.block as LinksWithArrowsType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsInfoboxSlim') {
    return (
      <>
        <DatoCmsInfoBox block={props.block as InfoBoxTypeSlim['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTextWithImageSlim') {
    return (
      <>
        <DatoCmsTextWithImageSlim block={props.block as TextWithImageSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsImageWithDeviceSlim') {
    return (
      <>
        <DatoCmsImageWithDeviceSlim block={props.block as ImageWithDeviceSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsIconCardsWithTextSlim') {
    return (
      <>
        <DatoCmsIconCardsWithTextSlim block={props.block as IconCardsWithTextSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTestimonialSliderSlim') {
    return (
      <>
        <DatoCmsTestimonialSliderSlim block={props.block as TestimonialSliderSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTestimonialVideoSliderSlim') {
    return (
      <>
        <DatoCmsTestimonialVideoSliderSlim block={props.block as TestimonialVideoSliderSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsFullwidthImageSlim') {
    return (
      <>
        <DatoCmsFullwidthImageSlim block={props.block} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTwoColumnHeroSlim') {
    return (
      <>
        <DatoCmsTwoColumnHeroSlim block={props.block as TwoColumnHeroSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsCampaignWithDeviceSlim') {
    return (
      <>
        <DatoCmsCampaignWithDeviceSlim block={props.block as CampaignWithDeviceSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsHeroWithImageAndDeviceSlim') {
    return (
      <>
        <DatoCmsHeroWithImageAndDeviceSlim block={props.block as HeroWithImageAndDeviceSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsHeroWithBackgroundImageSlim') {
    return (
      <>
        <DatoCmsHeroWithBackgroundImageSlim block={props.block as HeroWithBackgroundImageSlimType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsBannerWithEmail') {
    return (
      <>
        <DatoCmsBannerWithEmail block={props.block as BannerWithEmailType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsImageSlim') {
    return (
      <>
        <DatoCmsImageSlim block={props.block as ImageSlimType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsAccordionSlim') {
    return (
      <>
        <DatoCmsAccordionSlim block={props.block as AccordionSlimType['block']} noPaddingX={props.template === Template.BLOG_POST} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsIconCardsSlim') {
    return (
      <>
        <DatoCmsIconCardsSlim block={props.block as IconCardsSlimBlockType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsImgCardsSlim') {
    return (
      <>
        <DatoCmsImgCardsSlim block={props.block as ImgCardsSlimType} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsProductVideoTabsSlim' && props.blockSpecificData?.pageData) {
    return (
      <>
        <DatoCmsProductVideoTabsSlim block={props.block as ProductVideoTabsSlimType['block']} pageData={props.blockSpecificData.pageData} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsPricingCardsSlim') {
    return (
      <>
        <DatoCmsPricingCards block={props.block as PricingCardsSlimType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTwoColumnRichtextImage') {
    return (
      <>
        <DatoCmsTwoColumnRichtextImage
          block={props.block as DatoCmsTwoColumnRichtextImageType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsTwoColumnImageRichtext') {
    return (
      <>
        <DatoCmsTwoColumnImageRichtext
          block={props.block as DatoCmsTwoColumnImageRichtextType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsShownewscarousel') {
    return (
      <>
        <DatoCmsShownNewsCarousel />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsVideo') {
    return (
      <>
        <DatoCmsVideo block={props.block as VideoType['block']} />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsImage') {
    return (
      <>
        <DatoCmsImage
          block={props.block as DatoCmsImageType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsRichText') {
    return (
      <>
        <DatoCmsRichtext
          block={props.block as RichTextType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
          isBlogPost={props.template === Template.BLOG_POST}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsCalendly') {
    return (
      <>
        <DatoCmsCalendly
          block={props.block as CalendlyType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsSalesforceForm') {
    return (
      <>
        <DatoCmsSalesforceForm
          block={props.block as SalesforceLightningOutType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsThreeColumnText') {
    return (
      <>
        <DatoCmsThreeColumnText
          block={props.block as DatoCmsThreeColumnTextType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsThreeColumnCard') {
    return (
      <>
        <DatoCmsThreeColumnCard
          block={props.block as DatoCmsThreeColumnCardType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCms2ColumnText') {
    return (
      <>
        <DatoCms2ColumnText
          block={props.block as DatoCms2ColumnTextType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsOneColumnText') {
    return (
      <>
        <DatoCmsOneColumnText
          block={props.block as DatoCmsOneColumnTextType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsHeadline') {
    return (
      <>
        <DatoCmsHeadline
          block={props.block as DatoCmsHeadlineType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsBanner') {
    return (
      <>
        <DatoCmsBanner
          block={props.block as DatoCmsBannerType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }
  if (props.block.__typename === 'DatoCmsBannerWithSignup') {
    return (
      <>
        <DatoCmsBannerWithSignup
          block={props.block as BannerWithSignupType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsIconCardsWithTextReference') {
    return (
      <>
        <DatoCmsIconCardsWithTextReference block={props.block as IconCardsWithTextReferenceType['block']} pageData={props.blockSpecificData.pageData} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsTextWithImageSlimReference') {
    return (
      <>
        <DatoCmsTextWithImageSlimReference block={props.block as TextWithImageSlimReferenceType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsFaqsReference') {
    return (
      <>
        <DatoCmsFaqsReference block={props.block as FAQReferenceType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCms1ColumnYoutube') {
    return (
      <>
        <DatoCms1ColumnYoutube
          block={props.block as DatoCms1ColumnYoutubeType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCms3ColumnYoutube') {
    return (
      <>
        <DatoCms3ColumnYoutube
          block={props.block as DatoCms3ColumnYoutubeType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsFaq') {
    return (
      <>
        <DatoCmsFAQ block={props.block as FAQType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsTypeform') {
    return (
      <>
        <DatoCmsTypeform
          block={props.block as TypeformType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsTwoColumnPriceTable') {
    return (
      <>
        <DatoCmsTwoColumnPriceTable
          block={props.block as DatoCmsTwoColumnPriceTableType['block']}
          nextBlockSameType={props.nextBlockSameType}
          previousBlockSameType={props.previousBlockSameType}
        />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsDownloadAppsSlim' && props.blockSpecificData?.appDownloadLinks) {
    return (
      <>
        <DatoCmsDownloadApps block={props.block as DowloadAppsSlimType['block']} appDownloadLinks={props.blockSpecificData.appDownloadLinks} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsProvenExpert') {
    return (
      <>
        <DatoCmsProvenExpert block={props.block as ProvenExpertProps['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsPricingAddOnsSection') {
    return (
      <>
        <DatoCmsPricingAddOns block={props.block as PricingAddOnsSectionType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsHeroWithLeftAlignedContentSlim') {
    return (
      <>
        <DatoCmsHeroLeftAlignedContentSlim block={props.block as HeroLeftAlignedContentSlimType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsNewsletter') {
    return (
      <>
        <DatoCmsNewsletter block={props.block as NewsLetterType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsPricingHeaderBlock') {
    return (
      <>
        <DatoCmsPricingHeader {...(props.block as PricingHeaderBlockType['block'])['pricingHeaderModel']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsRelatedBlogPostsBlock') {
    const onlyBecauseTypescriptNeedsIt = {
      block: props.block as RelatedBlogPostsType['block']
    };
    return (
      <>
        <DatoCmsRelatedBlogPostsBlock relatedBlogPostsByTag={props.relatedBlogPostsByTag[onlyBecauseTypescriptNeedsIt.block.tag.name] || []} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsTextWithVideo') {
    return (
      <>
        <DatoCmsTextWithVideo block={props.block as TextWithVideoType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsHeader') {
    return (
      <>
        <DatoCmsHeader block={props.block as HeaderType['block']} isBlogPost={props.template === Template.BLOG_POST} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsCalendlyWithImage') {
    return (
      <>
        <DatoCmsCalendlyWithImage block={props.block as CalendlyWithImageType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsImageWithLogo') {
    return (
      <>
        <DatoCmsImageWithLogo block={props.block as ImageWithLogoType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsSocialMediaPresence') {
    return (
      <>
        <DatoCmsSocialMediaPresence block={props.block as SocialMediaPresenceType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsStorylaneDemo') {
    return (
      <>
        <DatoCmsStorylaneDemo block={props.block as StorylaneDemoType['block']} />
      </>
    );
  }

  if (props.block.__typename === 'DatoCmsTableOfContent') {
    return <DatoCmsTableOfContent block={props.block as TableOfContentType['block']} />;
  }

  if (props.block.__typename === 'DatoCmsIconCardsWithIconButtonsBlock') {
    return <DatoCmsIconCardsWithIconButtonsBlock block={props.block as IconCardsWithIconButtonsType['block']} />;
  }

  if (props.block.__typename === 'DatoCmsIndustryTeaser') {
    return <DatoCmsIndustryTeaser block={props.block as IndustryTeaserType['block']} />;
  }

  if (props.block.__typename === 'DatoCmsBlogpostCtaBanner') {
    return <DatoCmsBannerWithButtonSlim block={props.block as BlogpostCTABannerType['block']} />;
  }

  return <div>This block {props.block.__typename} is not implemented</div>;
};
